// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// RxJS
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil, tap, first } from 'rxjs/operators';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
// Auth
import { AuthNoticeService, Login } from '../../../../core/auth';

import { AuthenticationService, UserService } from '../../../../_services';
import{ GlobalVariables } from '../../../../_common/global-variables';

@Component({
	selector: 'kt-login',
	templateUrl: './login.component.html',
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
	// Public params
	loginForm: FormGroup;
	loading = false;
	isLoggedIn$: Observable<boolean>;
	errors: any = [];
	submitted = false;

	tarifa = null;
	tarifaStr = "";


	private unsubscribe: Subject<any>;

	private returnUrl: any;

	// Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 * @param route
	 */
	constructor(
		private router: Router,
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		private userService: UserService,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		private authenticationService: AuthenticationService
	) {
		this.unsubscribe = new Subject();

		// redirect to home if already logged in
        if (this.authenticationService.currentUserValue) { 
            this.router.navigate(['/']);
        }

		this.route.paramMap.subscribe(params => {
			this.tarifa = params.get("tarifa");

			if(this.tarifa) {
				this.tarifaStr = this.tarifa.split('-')[0];
			}

			
		})
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.initLoginForm();

		// redirect back to the returnUrl before login
		this.route.queryParams.subscribe(params => {
			this.returnUrl = params.returnUrl || '/';
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null);
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initLoginForm() {
		// demo message to show
		/*if (!this.authNoticeService.onNoticeChanged$.getValue()) {
			const initialNotice = `DEMO: Usa la cuenta
			<strong>${DEMO_PARAMS.EMAIL}</strong> y la contraseña
			<strong>${DEMO_PARAMS.PASSWORD}</strong> para continuar.`;
			this.authNoticeService.setNotice(initialNotice, 'info');
		}*/

		this.loginForm = this.fb.group({
			email: [null, Validators.compose([
				Validators.required,
				Validators.email,
				//Validators.minLength(3),
				//Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			],
			password: [null, Validators.compose([
				Validators.required,
				//Validators.minLength(3),
				//Validators.maxLength(100)
			])
			]
		});
	}

	/**
	 * Form Submit
	 */
	submit() {
		if(this.loading) return;
		
		this.submitted = true;
		
		const controls = this.loginForm.controls;
		/** check form */
		if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading = true;

		const authData = {
			email: controls.email.value,
			password: controls.password.value
		};

		this.authenticationService.login(authData.email, authData.password)
            .pipe(first())
            .subscribe(
                async data => {
					let user = this.authenticationService.currentUserValue;

					if(user.CodigoIsoIdioma) {
                        let textosEs = await this.userService.getTextos("es");

                        let textos = [];
                        if(user.CodigoIsoIdioma != "es") {
                            textos = await this.userService.getTextos(user.CodigoIsoIdioma);
                        }

                        let hash = {};
                        for(let texto of textosEs) {
                            hash[texto.CodigoTexto] = texto.Traduccion;
                        }
                        for(let texto of textos) {
                            hash[texto.CodigoTexto] = texto.Traduccion;
                        }
                        GlobalVariables.textos = hash;
                    } else {
						let textosEs = await this.userService.getTextos("es");
                        let hash = {};
                        for(let texto of textosEs) {
                            hash[texto.CodigoTexto] = texto.Traduccion;
                        }
                        GlobalVariables.textos = hash;
					}

					this.router.navigateByUrl(this.returnUrl);                 
                },
                error => {
					console.log(error);
					this.loading = false;
					if(error == "Bad Request") {
						this.authNoticeService.setNotice("Su cuenta se encuentra inactiva. Revisa tu correo y pulsa en el enlace de validación.", 'warning');
					} else {
						this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');
					}
					this.cdr.markForCheck();
                });
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control || !this.submitted) {
			return false;
		}

		if(!validationType) {
			const result = control.invalid && (control.dirty || control.touched);
			return result;
		} else {
			const result = control.hasError(validationType) && (control.dirty || control.touched);
			return result;
		}

		
	}
}
